<template>
  <el-dialog
    title=""
    :visible.sync="visible"
    :before-close="handleClose"
    width="50%"
  >
    <div class="title">本次审核未通过记录为：{{ count }}条</div>
    <el-form ref="form" :rules="formRules" :model="form" label-width="100px">
      <el-form-item prop="noPassReason" label-width="0px">
        <el-input
          type="textarea"
          :rows="3"
          v-model="form.noPassReason"
          placeholder="请输入未通过意见"
          clearable
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submitForm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { confirmMsg } from '@/utils/common'
import * as api from '@/api/index'
export default {
  name: 'RegistrationReviewNoPass',
  data() {
    return {
      visible: false,
      count: 0,
      selectedList: [],
      form: {
        noPassReason: '',
      },
      formRules: {
        noPassReason: [
          { required: true, message: '请输入未通过意见', trigger: 'blur' },
        ],
      },
      uid: '',
    }
  },
  props: ['uName'],
  methods: {
    // 初始化
    init(selectedList, uid) {
      this.visible = true
      this.uid = uid
      this.selectedList = selectedList
      this.count = selectedList.length
    },

    handleClose(msg) {
      this.visible = false
      // this.$refs.form.resetFields()
      this.$emit('close-registration-review-not-pass', msg)
    },

    // 提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const selectedList = this.selectedList
          confirmMsg('是否批准不通过这些数据？', async () => {
            let obj = {
              ids: '',
              infoType: '',
              sIds: '',
              verifyStatus: '0',
              uid: this.uid,
              uName: this.uName,
              noPassReason: this.form.noPassReason,
            }
            for (let i = 0; i < selectedList.length; i++) {
              obj.ids += selectedList[i].orderId + ','
              obj.infoType += selectedList[i].infoType + ','
              obj.sIds += selectedList[i].uid + ','
            }
            const { code } = (await api.updateApproveStatus(obj)).data
            if (code === 100000) {
              obj.verifyStatus = null
              // const res = (await api.doRefund(obj)).data
              // if (res.code === 100000) {
              this.$message({
                type: 'success',
                message: `本次审核不通过记录为：${selectedList.length}`,
              })
              this.handleClose('success')
              // }
            }
          })
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.title {
  text-align: center;
  font-size: 20px;
}
</style>
